import AreaPicker from "@/components/AreaPicker";
import BankPicker from "@/components/BankPicker";
import { Input } from "@/components/Input";
import { makePlatformOnClick } from "@/components/utils";
import { useUserAuthContext } from "@/routes/routesAuths/userAuth";
import { safeRealName } from "@/utils/safe";
import { Form, Image } from "antd-mobile";
import { FormContentProps } from ".";
import { cn } from "@/libs";
import styles from "../index.module.scss";
import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";

export const BankForm = (props: FormContentProps) => {
  const { user } = useUserAuthContext();
  const [searchParams] = useSearchParams();
  const isMerchant = useMemo(() => {
    return searchParams.get('m') === '1' || searchParams.get('m') === '2';
  }, [ searchParams]);
  return (
    <>
      <Form.Item label="持卡人姓名" name={"realName"}>
        {
          isMerchant ? <Input placeholder="请输入持卡人姓名" /> : safeRealName(user.realName)
        }
      </Form.Item>
      <Form.Item label="银行卡" name={"bankNo"}>
        <Input placeholder="请输入银行卡号" />
      </Form.Item>
      <Form.Item label="银行名称" name={"bank"}>
        <BankPicker placeholder="请选择银行" />
      </Form.Item>
      <Form.Item label="开户所在地" name={"area"}>
        <AreaPicker placeholder="请选择" />
      </Form.Item>
      <Form.Item label="开户支行" name={"bankBranch"}>
        <Input placeholder="选填" autoComplete="off" />
      </Form.Item>
      <Form.Item label="资金密码" name={"securePassword"}>
        <Input
          type={"password"}
          placeholder="6位纯数字资金密码"
          autoComplete="new-password"
        />
      </Form.Item>
      <Form.Item
        className={cn(styles.imageCodeForm)}
        label="验证码"
        name={"code"}
        extra={
          <div
            {...makePlatformOnClick((e) => {
              e.preventDefault();
              props.flushCodeImage();
            })}
          >
            <Image className={cn(styles.imageCode)}  src={props.codeImage} alt="code" />
          </div>
        }
      >
        <Input placeholder="图片验证码" autoComplete="new-password" />
      </Form.Item>
    </>
  );
};
